<template>
  <div>
    <lb-dialog :value="value" :heading="viewdata.typetext" width="1000" :loading="viewloading" @input="$emit('input', $event)">
      <template v-slot:body>
        <div v-if="viewdata._id" class="d-flex flex-column gap-6">
          <div v-if="viewdata.type !== 'glselectionchange'" class="d-flex align-center">
            <!-- RU Level Materiality File Upload -->
            <ApprovalCycleStats
              :viewdata="viewdata"
              :total_cycle="total_cycle"
              :proccesed_cycle="proccesed_cycle"
            />
            <div v-if="viewdata.type === 'accesschange' || viewdata.type === 'bulkaccesschange'">
              <v-chip class="noTransform ru-info-chip gap-2 align-center">
                <span><v-icon>mdi-information-outline</v-icon> New users will be added/removed inline with the information provided below.</span>
              </v-chip>
            </div>  
            <div v-if="viewdata.type === 'fileaccesschange'" class="">
              <v-chip class="noTransform ru-info-chip gap-2 align-center">
                <span class="d-flex align-center gap-2"><v-icon>mdi-information-outline</v-icon> All existing user of the below {{$nova.labelsName('approvals_page','ru_entity_plural_label','Reporting Units').toLowerCase()}} will be replaced by the user list
              provided under each {{$nova.labelsName('access_management','ru_entity_plural_label','Reporting Units').toLowerCase()}} detail.</span>
              </v-chip>
            </div>
            <v-spacer></v-spacer>
           <v-btn color="primary" @click="$emit('download-failed', viewdata._id)" v-if="materialityTypes.includes(viewdata.type) && errorReportAvailable && viewdata.stage === 3">
            <v-icon left>mdi-download</v-icon>
            <span>Download Failed Records</span>
            </v-btn>
            <v-btn icon @click="$emit('refresh', viewdata)"> <v-icon>mdi-refresh</v-icon> </v-btn>
            <div class="ml-4"
              v-if="['bulkmaterialityrulevel','filematerialityrulevel','bulkmaterialitygllevel','filematerialitygllevel','materialityrulevel','materialitygllevel','materialitysllevel','bulkmaterialitysllevel','filematerialitysllevel'].indexOf(viewdata.type) > -1">
              <v-icon @click="viewinfo=true">mdi mdi-information-outline</v-icon>
            </div>
          </div>

          <div class="d-flex flex-column gap-4">
            <!-- Module -->
            <ApprovalDetailRow  label="Module">
                <span v-if="viewdata.reporting_type === 'bs'" class="font-weight-bold">
                  Balance Sheet
                </span>
                <span v-else-if ="viewdata.reporting_type === 'pl'" class="font-weight-bold">
                  Profit & Loss
                </span>
                <span v-else class="font-weight-bold">
                  -
                </span>
            </ApprovalDetailRow>

            <!-- Cycle -->
            <ApprovalDetailRow v-if="viewdata.data?.[0]?.cycle" label="Cycle">
                <span v-if="viewdata.data[0]?.cycle === 'Actual'" class="font-weight-bold">
                  {{ actualLabel }}
                </span>
                <span v-else class="font-weight-bold">
                  {{ forecastLabel }}
                </span>
            </ApprovalDetailRow>

            <!-- Applicable Period -->
            <ApprovalDetailRow v-if="viewdata.data?.[0]?.from" label="Applicable Period">
                <span class="font-weight-bold">
                  {{ $nova.formatDate(viewdata.data[0]?.from, "MM - YYYY") }}
                </span>
            </ApprovalDetailRow>

            <!-- Network -->
            <ApprovalDetailRow
              v-if="['materialityrulevel','materialitygllevel','materialitysllevel'].includes(viewdata.type)
                && viewdata.network_details?.[0]?.name"
              :label="$nova.labelsName('approvals_page','division_label','Network')"
            >
                <span class="font-weight-bold">{{ viewdata.network_details[0].name }}</span>
            </ApprovalDetailRow>

            <!-- Region -->
            <ApprovalDetailRow
              v-if="['materialityrulevel','materialitygllevel','materialitysllevel'].includes(viewdata.type)
                && viewdata.region_details?.[0]?.name"
              :label="$nova.labelsName('approvals_page','region_label','Region')"
            >
                <span class="font-weight-bold">{{ viewdata.region_details[0].name }}</span>
            </ApprovalDetailRow>

            <!-- Country -->
            <ApprovalDetailRow
              v-if="['materialityrulevel','materialitygllevel','materialitysllevel'].includes(viewdata.type)
                && viewdata.country_details?.[0]?.name"
              :label="$nova.labelsName('approvals_page','country_label','Country')"
            >
                <span class="font-weight-bold">{{ viewdata.country_details[0].name }}</span>
            </ApprovalDetailRow>

            <!-- Status -->
            <ApprovalDetailRow :label="$nova.labelsName('approvals_page','status_label','Status')">
                <status-indicator
                  :variant="getStageVariant(viewdata.stage)"
                  :custom-label="getStageLabel(viewdata.stage)"
                  size="sm"
                  outlined
                />
            </ApprovalDetailRow>
          </div>
          
          <ApprovalAccessChange :viewdata="viewdata" />
          
          <ApprovalFileAccessChange :viewdata="viewdata" />
          
          <!-- Bulk RU Level Materiality -->
          <ApprovalMaterialityRu 
            :viewdata="viewdata" 
            :gldata="gldata" 
            :proccesed_cycle="proccesed_cycle" 
          />

          <ApprovalMaterialityFile
            :viewdata="viewdata"
            :gldata="gldata"
            :proccesed_Ru="proccesed_Ru"
            :materialityDetailsPage="materialityDetailsPage"
          />

          <!-- Bulk GL Level Materiality -->
          <ApprovalMaterialityGl
            :viewdata="viewdata"
            :gldata="gldata"
            :proccesed_cycle="proccesed_cycle"
            :viewloading="viewloading"
            :proccesed_Ru="proccesed_Ru"
          />

          <ApprovalGlSelectionChange
            :viewdata="viewdata"
            :viewloading="viewloading"
            :gldata="gldata"
          />

        </div>
        <div v-else-if="viewloading" class="grey--text py-4 text-center font-size-lg">Loading Data...</div>
        <div v-else class="grey--text py-4 text-center font-size-lg">No data found</div>
      </template>
      <template v-slot:actions>
        <div v-if="(viewdata.type === 'filematerialitygllevel' || viewdata.type === 'filematerialityrulevel' || viewdata.type === 'filematerialitysllevel') && (Object.keys(gldata).length > 25)" class="grey--text py-4 text-center font-size-lg"> 
          <v-btn @click="$emit('update:materialityDetailsPage', materialityDetailsPage - 1)" :disabled="materialityDetailsPage === 0"><v-icon>mdi mdi-arrow-left</v-icon></v-btn>
          <span class="ml-1 mr-1" v-if="(($nova.formatNumber((Object.keys(gldata).length)/25))-materialityDetailsPage-1) !== 0">{{ materialityDetailsPage+1}} of {{ $nova.formatNumber((Object.keys(gldata).length)/25) }}</span>
          <span class="ml-1 mr-1" v-if="(($nova.formatNumber((Object.keys(gldata).length)/25))-materialityDetailsPage-1) === 0">End</span>
          <v-btn @click="$emit('update:materialityDetailsPage', materialityDetailsPage + 1)" :disabled="(((Object.keys(gldata).length)/25)-materialityDetailsPage-1) <= 0"><v-icon>mdi mdi-arrow-right </v-icon></v-btn>
        </div>
        <v-spacer></v-spacer>
        <v-btn color="secondaryBtn" v-if="viewdata.stage === 0 && display !== 'view'" class="" @click="$emit('reject', viewdata)"><span>Reject</span></v-btn>
        <v-btn color="primary" @click="$emit('retry', viewdata)" v-if="viewdata.stage === 3 && display !== 'view'"><span>Retry</span></v-btn>
        <v-btn color="primary" @click="$emit('approve', viewdata)" v-if="viewdata.stage === 0 && display !== 'view' "><span>Approve</span></v-btn>
      </template>
    </lb-dialog>
    <lb-dialog v-model="viewinfo" width="500" heading="Custom Notation">
      <template v-slot:body>
        <v-card-text class="pa-0">
          <div class="notation-table">

            <div class="notation-row">
              <div class="notation-key">{{ $nova.labelsName('approvals_page', 'commentary_local_control_amount_shortform_label', 'LC AMT') }}</div>
              <div class="notation-value">
                {{ $nova.labelsName('approvals_page','commentary_local_control_amount_fullform_label','Local Control Amount') }}
              </div>
            </div>

            <div class="notation-row">
              <div class="notation-key">{{ $nova.labelsName('approvals_page', 'commentary_local_control_percentage_shortform_label', 'LC %') }}</div>
              <div class="notation-value">
                {{ $nova.labelsName('approvals_page','commentary_local_control_percentage_fullform_label','Local Control Percentage') }}
              </div>
            </div>

            <div class="notation-row">
              <div class="notation-key">{{ $nova.labelsName('approvals_page', 'commentary_local_management_amount_shortform_label', 'LM AMT') }}</div>
              <div class="notation-value">
                {{ $nova.labelsName('approvals_page','commentary_local_management_amount_fullform_label','Local Management Amount') }}
              </div>
            </div>

            <div class="notation-row">
              <div class="notation-key">{{ $nova.labelsName('approvals_page', 'commentary_local_management_percentage_shortform_label', 'LM %') }}</div>
              <div class="notation-value">
                {{ $nova.labelsName('approvals_page','commentary_local_management_percentage_fullform_label','Local Management Percentage') }}
              </div>
            </div>

            <div class="notation-row">
              <div class="notation-key">{{ $nova.labelsName('approvals_page', 'commentary_regional_control_amount_shortform_label', 'RC AMT') }}</div>
              <div class="notation-value">
                {{ $nova.labelsName('approvals_page','commentary_regional_control_amount_fullform_label','Regional Control Amount') }}
              </div>
            </div>

            <div class="notation-row">
              <div class="notation-key">{{ $nova.labelsName('approvals_page', 'commentary_regional_control_percentage_shortform_label', 'RC %') }}</div>
              <div class="notation-value">
                {{ $nova.labelsName('approvals_page','commentary_regional_control_percentage_fullform_label','Regional Control Percentage') }}
              </div>
            </div>

            <div class="notation-row">
              <div class="notation-key">{{ $nova.labelsName('approvals_page', 'commentary_regional_management_amount_shortform_label', 'RM AMT') }}</div>
              <div class="notation-value">
                {{ $nova.labelsName('approvals_page','commentary_regional_management_amount_fullform_label','Regional Management Amount') }}
              </div>
            </div>

            <div class="notation-row">
              <div class="notation-key">{{ $nova.labelsName('approvals_page', 'commentary_regional_management_percentage_shortform_label', 'RM %') }}</div>
              <div class="notation-value">
                {{ $nova.labelsName('approvals_page','commentary_regional_management_percentage_fullform_label','Regional Management Percentage') }}
              </div>
            </div>

          </div>
        </v-card-text>
      </template>
    </lb-dialog>

  </div>
</template>

<script>
import ApprovalCycleStats from './ApprovalCycleStats.vue';
import ApprovalAccessChange from './ApprovalAccessChange.vue';
import ApprovalFileAccessChange from './ApprovalFileAccessChange.vue';
import ApprovalMaterialityRu from './ApprovalMaterialityRu.vue';
import ApprovalMaterialityGl from './ApprovalMaterialityGl.vue';
import ApprovalMaterialityFile from './ApprovalMaterialityFile.vue';
import ApprovalGlSelectionChange from './ApprovalGlSelectionChange.vue';
import ApprovalDetailRow from './ApprovalDetailRow.vue';
import StatusIndicator from '../../../components/StatusIndicator.vue';
import { STATUS_VARIANTS } from '../../../utils/statusConstants';

export default {
  name: 'ApprovalDetailsDialog',
  components: {
    ApprovalCycleStats,
    ApprovalAccessChange,
    ApprovalFileAccessChange,
    ApprovalMaterialityRu,
    ApprovalMaterialityGl,
    ApprovalMaterialityFile,
    ApprovalGlSelectionChange,
    ApprovalDetailRow,
    StatusIndicator
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    viewdata: {
      type: Object,
      default: () => ({})
    },
    viewloading: {
      type: Boolean,
      default: false
    },
    total_cycle: {
      type: Array,
      default: () => []
    },
    proccesed_cycle: {
      type: Array,
      default: () => []
    },
    proccesed_Ru: {
      type: Array,
      default: () => []
    },
    materialityTypes: {
      type: Array,
      default: () => []
    },
    errorReportAvailable: {
      type: Boolean,
      default: false
    },
    gldata: {
      type: Object,
      default: () => ({})
    },
    materialityDetailsPage: {
      type: Number,
      default: 0
    },
    display: {
      type: String,
      default: 'view'
    }
  },
  computed: {
    /**
     * Dynamic label for Actual based on reporting_type
     * Returns balance sheet specific label when type is 'bs', otherwise default
     */
    actualLabel() {
      return this.viewdata.reporting_type === 'bs'
        ? this.$nova.labelsName('approvals_page', 'actual_label_balancesheet', 'Actual')
        : this.$nova.labelsName('approvals_page', 'actual_label', 'Actual');
    },
    /**
     * Dynamic label for Proforma based on reporting_type
     * Returns balance sheet specific label when type is 'bs', otherwise default
     */
    proformaLabel() {
      return this.viewdata.reporting_type === 'bs'
        ? this.$nova.labelsName('approvals_page', 'proforma_shortform_label_balancesheet', 'Proforma')
        : this.$nova.labelsName('approvals_page', 'proforma_shortform_label', 'Proforma');
    },
    /**
     * Dynamic label for Forecast based on reporting_type
     * Returns balance sheet specific label when type is 'bs', otherwise default
     */
    forecastLabel() {
      return this.viewdata.reporting_type === 'bs'
        ? this.$nova.labelsName('approvals_page', 'forecast_shortform_label_balancesheet', 'Forecast')
        : this.$nova.labelsName('approvals_page', 'forecast_shortform_label', 'Forecast');
    },
  },
  data() {
    return {
      viewinfo: false,
    }
  },
  methods: {
    getStageVariant(stage) {
      const map = {
        'Open': STATUS_VARIANTS.LOCAL_AWAITED,
        0: STATUS_VARIANTS.LOCAL_AWAITED,
        'Approved': STATUS_VARIANTS.APPROVED,
        1: STATUS_VARIANTS.APPROVED,
        'Rejected': STATUS_VARIANTS.LOCAL_REJECTED,
        '-1': STATUS_VARIANTS.LOCAL_REJECTED,
        'In Progress': STATUS_VARIANTS.PENDING,
        'inProgress': STATUS_VARIANTS.PENDING,
        2: STATUS_VARIANTS.PENDING,
        'Failed': STATUS_VARIANTS.REGIONAL_REJECTED,
        'Retry': STATUS_VARIANTS.REGIONAL_REJECTED,
        3: STATUS_VARIANTS.REGIONAL_REJECTED,
      };
      return map[stage] || STATUS_VARIANTS.UNKNOWN;
    },
    getStageLabel(stage) {
      if (stage === 'Open' || stage === 0) return 'Open';
      if (stage === 'Approved' || stage === 1) return this.$nova.labelsName('approvals_page','commentary_approved_label','Approved');
      if (stage === 'Rejected' || stage === -1) return this.$nova.labelsName('approvals_page','commentary_rejected_label','Rejected');
      if (stage === 'inProgress' || stage === 2) return 'In Progress';
      if (stage === 'Retry' || stage === 3 || stage === 'Failed') return 'Failed';
      return stage;
    }
  }
}
</script>


<style>
.notation-table {
  border: 1px solid var(--grey-100);
  border-radius: 10px;
  overflow: hidden;
}

.notation-row {
  display: grid;
  grid-template-columns: 120px 1fr;
  border-bottom: 1px solid var(--grey-100);
}

.notation-row:last-child {
  border-bottom: none;
}

.notation-key {
  padding: 14px 16px;
  font-weight: 600;
  color: var(--grey-900);
  background: var(--grey-white);
  border-right: 1px solid var(--grey-100);
}

.notation-value {
  padding: 14px 16px;
  color: var(--grey-600);
  background: var(--grey-white);
}
.ru-info-chip {
  border: 1px solid var(--grey-100);
  background: var(--grey-50) !important;
}
</style>